
import { NgModule, ErrorHandler } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { HttpModule } from '@angular/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LoginService } from './shared/login.service';
import { MatInputModule, MatAutocompleteModule, MatSlideToggleModule, MatIconModule, MatButtonModule, MatDialogModule, MatSnackBarModule, MatSelectModule } from '@angular/material';
import { LoginRoutingModule, ROUTABLE_COMPONENTS } from './login.routing';
import { LoginComponent } from './login.component';
import { LoggingService } from '../../../shared/service/logging.service';
import { DataService } from '../../../shared/service/data.service';
import { UtilityService } from '../../../shared/common/utility.service';
import { ErrorService } from '../../../shared/error/error.service';
import { NotificationService } from '../../../shared/service/notification.service';
import { SnackbarModule } from '../../../shared/snackbar/snackbar.module';
import { SidebarModule } from '../../../shared/sidebar/sidebar.module';

@NgModule({
    imports: [
        BrowserModule, FormsModule, ReactiveFormsModule, BrowserAnimationsModule, CommonModule, BrowserModule, FormsModule, HttpModule,
        LoginRoutingModule, MatInputModule, MatAutocompleteModule, MatSlideToggleModule, MatIconModule, MatButtonModule, MatDialogModule,
        MatSnackBarModule, SnackbarModule, MatSelectModule,
        SidebarModule
    ],
    entryComponents: [],
    exports: [
        MatInputModule, MatAutocompleteModule, MatSlideToggleModule, MatIconModule, MatButtonModule, MatDialogModule, MatSnackBarModule
    ],
    declarations: [
        LoginComponent,
        ROUTABLE_COMPONENTS
    ],
    providers: [
        /*{
          provide: ErrorHandler,
          useClass: GlobalErrorHandler
        },*/
        DataService, UtilityService, ErrorService, LoggingService, LoginService, NotificationService
    ],
    bootstrap: [LoginComponent]
})
export class LoginModule {
}
